// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__x8+rv","searchIconWrapper":"styles_searchIconWrapper__0hPpm"};